// src/analytics/RevenueCard.jsx
import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #FFFAF5;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h2`
  color: #FF7C24;
  font-size: 20px;
  margin-bottom: 1rem;
`;

const StatText = styled.p`
  font-size: 16px;
  color: #232830;
`;

export default function RevenueCard({ revenueData = [] }) {
  return (
    <Card>
      <Title>Revenue</Title>

      <StatText> <a href="https://dashboard.stripe.com/customers?ending_before=cus_O6CVCdrmp6324E"> Paid Customers Stripe :</a>     </StatText>
      <StatText>Paid Customers RevenueCat :  https://app.revenuecat.com/overview </StatText>

      <StatText> {revenueData.length}</StatText>

    </Card>



    
  );
}
